module.exports = __webpack_public_path__ + "img/25.90bce115.png";